<template>
  <div style="height: 600px; width: 100%">
    <!-- Example from https://vue2-leaflet.netlify.app/examples/simple.html -->
    <div style="text-align: left; overflow: auto;">
      <p v-if="markerCount > 1">
        <b>Location description:</b> Data is from {{ markerCount }} locations<br>
        Click the marker labels to see GPS location<br>
        <!-- ß -->
      </p>
      <p v-else><b>Location Description:</b>  {{ mapData[0][2] }}<br>
        <b>GPS Location:</b> ({{ mapData[0][0] }}, {{ mapData[0][1] }})<br>
        <!-- Current map center is at {{ currentCenter }} at zoom: {{ currentZoom }} -->
      </p>
    </div>
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :bounds="latLngData"
      :padding="[10, 10, 10, 10]"
      :options="mapOptions"
      style="height: 80%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer :url="url" :attribution="attribution"/>
      <l-control-layers style="text-align: left;"  position="topright"  ></l-control-layers>
      <l-tile-layer style="text-align: left;"
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"/>

      <l-control-scale position="bottomright" :imperial="true" :metric="false"></l-control-scale>
      <l-marker :lat-lng="[marker[0], marker[1]]" v-for="(marker, index) in mapData" :key="`marker-${index}`">
        <l-tooltip :options="{ permanent: true, interactive: true }">
          <div @click="showParagraph = !showParagraph">
            {{ marker[2] }}
            <p v-show="showParagraph">Lat: {{ marker[0] }}, Long: {{ marker[1] }}<br> {{ marker[3] }}</p>
          </div>
        </l-tooltip>
      </l-marker>
    </l-map>
    <div style="height: 200px; text-align: left; overflow: auto;" v-if="!allArrayItemsNull(dateArray)">
      <p v-if="markerCount > 1"><b>Collection date:</b> Samples collected on multiple dates</p>
      <p v-else><b>Collection date:</b> {{ mapData[0][3] }}</p>
      <!-- <button @click="showLongText">
        Toggle long popup
      </button>
      <button @click="showMap = !showMap">
        Toggle map
      </button> -->
    </div>
  </div>
</template>

<script>
import { latLngBounds, latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LTooltip, LControlScale, LControlLayers } from "vue2-leaflet";
// import { LPopup } from "vue2-leaflet";

export default {
  name: "VBMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlScale,
    LControlLayers,
    // LPopup,
    LTooltip
  },
  props: {
    mapData: Array,
  },
  data() {
    return {
      zoom: 6,
      center: latLng(this.mapData[0][0], this.mapData[0][1]),
      latLngData: [],
      bounds: latLngBounds(this.latLngData),
      dateArray: [],
      
      tileProviders: [
        {
          name: 'Street',
          visible: true,
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
          attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
        },
        {
          name: 'Terrain',
          visible: false,
          url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png',
          attribution:
            'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        },
        {
          name: 'Satellite ',
          visible: false,
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        },
        // {
        //   name: 'Light',
        //   visible: false,
        //   url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
        //   attribution:
        //     '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        // },
        {
          name: 'Dark',
          visible: false,
          url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png',
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ' +
              '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
              'Imagery © <a href="http://mapbox.com">Mapbox</a>'
        },
      ],

      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      attribution:
        'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
      currentZoom: 6,
      currentCenter: latLng(this.lat, this.long),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 17,
      },
      showMap: true,
    };
  },
  computed: {
    markerCount: function () {
      return this.mapData.length;
    },
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    extractLatLngData() {
      if (this.mapData.length > 1){
        const latLngArray = [];

        this.mapData.forEach(function(arr) {
          const location = [];
          location[0] = arr[0];
          location[1] = arr[1];
          latLngArray.push(location);
        });

        this.latLngData = latLngArray;
      }
      else {
        this.latLngData = null;
      }
      
    },
    getDateArray() {
      const dateDataArray = [];

      this.mapData.forEach(function(obj) {
        dateDataArray.push(obj[3]);
      });

      this.dateArray = dateDataArray;
    },
    allArrayItemsNull: function(arr) {
      return arr.every(val => val === undefined || val === null);
    },
  },
  created: function() {
    this.extractLatLngData();
    this.getDateArray();
  },
};
</script>
